// extracted by mini-css-extract-plugin
export default {"cls1":"AttachmentOverlay-cls1_qj5","cls2":"AttachmentOverlay-cls2_SjS AttachmentOverlay-cls1_qj5"};